import { Iterable } from 'immutable';
import texts from './languages/';
// import * as Sentry from '@sentry/browser'

const defaultLanguage = {
  showSelectOption: true,
  countryCode: 'netherlands',
  selectOption: 'NL',
  language: 'nl',
  domainExtension: 'nl',
};

const mimeTypes = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  // 'image/gif',
  // 'image/webp',
  // 'image/avif',
  // 'image/heic',
  // 'image/heif',
];

// if countryCode needs to be changed keep it mind that it also has
// to change on the helper: {project-root}/web/app/mu-plugins/kroost/helpers.php
export const LANGUAGE_MAP = [
  defaultLanguage,
  {
    showSelectOption: true,
    countryCode: 'belgium',
    selectOption: 'BE',
    language: 'nl',
    domainExtension: 'be',
  },
  {
    showSelectOption: true,
    countryCode: 'germany',
    selectOption: 'DE',
    language: 'de',
    domainExtension: 'de',
  },
  {
    showSelectOption: true,
    countryCode: 'austria',
    selectOption: 'AT',
    language: 'de',
    domainExtension: 'at',
  },
  {
    //this is false because we dont have a country relative to the .com domain
    showSelectOption: false,
    countryCode: 'english',
    selectOption: 'EN',
    language: 'en',
    domainExtension: 'com',
  },
];

// Get the TLD from the URL
function getTld(url) {
  try {
    let hostname = new URL(url).hostname;
    // Extract TLD from hostname
    let parts = hostname.split('.');
    let tld = parts.length > 1 ? parts.pop() : '';
    return tld;
  } catch (error) {
    return null;
  }
}

const getLanguage = (href, query) => {
  const params = new URLSearchParams(query);
  const tld = params.has('lang') ? params.get('lang') : getTld(href);

  // Get the language and if we have a result then update the default language
  const tldLanguage = LANGUAGE_MAP.find(singleLanguage => singleLanguage.domainExtension === tld);
  return tldLanguage || defaultLanguage;
};

const { language, selectOption, domainExtension } = getLanguage(window.location.href, window.location.search);

// Set the global language variable
global.kroostApp = {
  language,
  country: selectOption,
  strings: window.APP_TEXTS || texts[language],
  domainExtension: domainExtension,
  dropZoneAccept: mimeTypes,
};

global.URL = window.URL || window.webkitURL;
(function() {
  'use strict';

  if (!('toBlob' in HTMLCanvasElement.prototype)) {
    Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
      value: function(callback, type, quality) {
        var binStr = atob(this.toDataURL(type, quality).split(',')[1]),
          len = binStr.length,
          arr = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
          arr[i] = binStr.charCodeAt(i);
        }
        callback(new Blob([arr], { type: type || 'image/png' }));
      },
    });
  }
})();

global.p = (...args) => {
  if (process.env.DEBUG) {
    args = args.map(arg => (arg instanceof Iterable ? ['immutable', arg.toJS(), arg] : arg));
    console.debug(...args);
  }
};

global.pe = (error, message) => {
  // if (!process.env.DEBUG) {
  //   Sentry.captureException(error)
  // }

  if (message) {
    console.error(message);
    console.error(error);
  }
};

global.API_HOST = __API_HOST__;

// if (!process.env.DEBUG) {
//   Sentry.init({
//     dsn: 'https://ef4e19e9b64c4cd19968c45e7424d04a@sentry.io/1526216'
//   })
// }



// WEBPACK FOOTER //
// ./app/global.js